var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "boardManage--search" },
        [
          (_vm.type === 1 ? _vm.$auth("data-board-customer::addMenu") : true)
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.add },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("dashboard-bi::board-management::新增菜单")
                      ) +
                      " "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { height: "582px" } },
        [
          _c("z-table", {
            attrs: {
              columns: _vm.columns,
              data: _vm.tableData,
              "row-key": "folderID",
              "tree-props": { children: "children" },
              pagination: false,
              "max-height": 550,
            },
            scopedSlots: _vm._u([
              {
                key: "folderName",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("i", {
                      staticClass: "iconfont",
                      class: _vm.iconMapping(row.icon),
                      staticStyle: { "margin-right": "8px" },
                    }),
                    _c("span", [_vm._v(_vm._s(row.folderName))]),
                  ]
                },
              },
              {
                key: "position",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(row.position))])]
                },
              },
              {
                key: "parentId",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            row.parentId
                              ? _vm.$t("dashboard-bi::board-management::菜单")
                              : _vm.$t("dashboard-bi::board-management::目录")
                          ) +
                          " "
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "openType",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$dataCheck(_vm.menuType[row.openType], "-")
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "openTarget",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.openTarget
                            ? row.openTarget === 1
                              ? _vm.$t("dashboard-bi::board-management::页签")
                              : _vm.$t("dashboard-bi::board-management::新窗口")
                            : "-"
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "isHide",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-switch", {
                      attrs: { value: !row.isHide },
                      on: {
                        change: function ($event) {
                          return _vm.checkShowOrHideMenu(row)
                        },
                      },
                    }),
                  ]
                },
              },
              {
                key: "operate",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    [
                      (
                        _vm.type === 1
                          ? _vm.$auth("data-board-customer::editMenu")
                          : true
                      )
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.edit(row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "dashboard-bi::board-management::编辑"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.type === 1 &&
                      _vm.$auth("data-board-customer::toSetting") &&
                      row.boardID
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.toAuth(row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "dashboard-bi::board-management::设置权限"
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      !(row.children && row.children.length) &&
                      (_vm.type === 1
                        ? _vm.$auth("data-board-customer::deleteMenu") &&
                          !row.sourceId
                        : true)
                        ? _c(
                            "el-button",
                            {
                              staticStyle: { color: "#E62C11" },
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteData(row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("system::function::delete")) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("AddOrUpdate", {
        attrs: { editRow: _vm.editRow, routerType: _vm.type },
        on: { refresh: _vm.getList },
        model: {
          value: _vm.visible,
          callback: function ($$v) {
            _vm.visible = $$v
          },
          expression: "visible",
        },
      }),
      _c("TransferDialog", {
        attrs: { editRow: _vm.editRow },
        on: { success: _vm.getList },
        model: {
          value: _vm.showRole,
          callback: function ($$v) {
            _vm.showRole = $$v
          },
          expression: "showRole",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }